import AdminTab from './adminTab';

export default AdminTab;
